import { render } from "./ProfileTab.vue?vue&type=template&id=f0f44604&scoped=true"
import script from "./ProfileTab.vue?vue&type=script&lang=js"
export * from "./ProfileTab.vue?vue&type=script&lang=js"

import "./ProfileTab.vue?vue&type=style&index=0&id=f0f44604&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f0f44604"]])

export default __exports__